import { z } from 'zod/v4'
import { FunctionInvokeCommandSchema } from './commands/function.invoke.schema'

// Compute service schema
export const ComputeServiceSchema = FunctionInvokeCommandSchema

// Compute service types
export type ComputeService = z.infer<typeof ComputeServiceSchema>
